// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"e077c676","223":"2568f15a"}[chunkId] + ".chunk.js";
};